import { InputTitle } from 'components/input/InputTitle';
import { Button, Spacing, TextInput } from 'enable-ui';

import { useChangePasswordController } from '../core/controller';

export const ChangePasswordPage = () => {
  const {
    password,
    oldPassword,
    confirmedPassword,
    handleChange,
    passwordStatus,
    confirmedPasswordStatus,
    oldPasswordStatus,
    disabled,
    handleSubmit,
  } = useChangePasswordController();

  return (
    <div style={{ width: '100%' }}>
      <Spacing spacing="xl" placement="bottom" type="margin">
        <InputTitle title="Current password" />
        <TextInput
          name="oldPassword"
          type="password"
          value={oldPassword}
          onChange={handleChange}
          helperText={oldPasswordStatus.helperText}
          color={oldPasswordStatus.color}
          containerStyle={{
            maxWidth: 'auto',
          }}
        />
      </Spacing>

      <Spacing spacing="xl" placement="bottom" type="margin">
        <InputTitle title="New password" />
        <TextInput
          name="password"
          type="password"
          value={password}
          onChange={handleChange}
          helperText={passwordStatus.helperText}
          color={passwordStatus.color}
          containerStyle={{
            maxWidth: 'auto',
          }}
        />
      </Spacing>

      <Spacing spacing="4xl" placement="bottom" type="margin">
        <InputTitle title="Confirm password" />
        <TextInput
          name="confirmedPassword"
          type="password"
          value={confirmedPassword}
          onChange={handleChange}
          helperText={confirmedPasswordStatus.helperText}
          color={confirmedPasswordStatus.color}
          containerStyle={{
            maxWidth: 'auto',
          }}
        />
      </Spacing>

      <Button
        variant="contained"
        color="primary"
        type="submit"
        size="large"
        disabled={disabled}
        onClick={() => handleSubmit()}
        style={{
          fontSize: '18px',
          lineHeight: '26px',
          fontWeight: 600,
        }}
      >
        Save
      </Button>
    </div>
  );
};
